import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastMessageService } from 'src/app/toastr.service';
import { environment } from 'src/environments/environment.prod';
import { LitigationComplaintsService } from '../litigation-complaints/litigation-complaints.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-view-all-litigation-complaints',
  templateUrl: './view-all-litigation-complaints.component.html',
  styleUrl: './view-all-litigation-complaints.component.scss'
})
export class ViewAllLitigationComplaintsComponent {

  litigationData: any[] = [];
  filteredLitigationData: any[] = [];
  loading = true;
  selectedOption: string = ''; // Default to 'pdf'
  isButtonDisabled: boolean = false;
  totalRecords: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  dropdownOptions = [
    { label: 'Captured Cases', value: 'captured' },
    { label: 'Not Captured Cases', value: 'not captured' },
    { label: 'Unprocessed Cases', value: 'unprocessed' },

  ];
  displayDeleteDialog: boolean = false;
  recordToDelete: any;
  UserIp: any;
  email: any;
  selectedStatus: string | null = 'pending';
  selectedLitigationData: any[] = [];
  displayBulkRejectDialog: boolean = false;
  dateError: string = '';
  private searchSubject = new Subject<string>();

  private caseNumberSubject = new Subject<string>();
  private plaintiffSubject = new Subject<string>();
  private defendantSubject = new Subject<string>();
  private caseStatusSubject = new Subject<string>();
  private courtNameSubject = new Subject<string>();

  caseNumberSearch: string = '';
  plaintiffSearch: string = '';
  defendantSearch: string = '';
  courtNameSearch: string = '';

  searchTerm: string = '';

  constructor(private LitigationComplaintsService: LitigationComplaintsService, private toastService: ToastMessageService,
    private sanitized: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.searchSubject.pipe(
      debounceTime(400), // wait for typing to pause
      distinctUntilChanged()
    ).subscribe((search: any) => {
      if (search.length >= 3 || search.length === 0) {
        this.loadLitigationData(1, this.pageSize, search, this.caseNumberSearch, this.plaintiffSearch, this.defendantSearch, this.courtNameSearch);
      }
    });

    this.caseNumberSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((caseNumber: string) => {
      this.caseNumberSearch = caseNumber;
      this.loadLitigationData(1, this.pageSize, this.searchTerm, caseNumber, this.plaintiffSearch, this.defendantSearch, this.courtNameSearch);
    });

    this.plaintiffSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((plaintiff: string) => {
      this.plaintiffSearch = plaintiff;
      this.loadLitigationData(1, this.pageSize, this.searchTerm, this.caseNumberSearch, plaintiff, this.defendantSearch, this.courtNameSearch);
    });

    this.defendantSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((defendant: string) => {
      this.defendantSearch = defendant;
      this.loadLitigationData(1, this.pageSize, this.searchTerm, this.caseNumberSearch, this.plaintiffSearch, defendant, this.courtNameSearch);
    });

    this.courtNameSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe((courtName: string) => {
      this.courtNameSearch = courtName;
      this.loadLitigationData(1, this.pageSize, this.searchTerm, this.caseNumberSearch, this.plaintiffSearch, this.defendantSearch, courtName);
    });

  }
  onSearchChange(value: string) {
    this.searchSubject.next(value.trim());
  }

  onCaseNumberChange(value: string) {
    this.caseNumberSubject.next(value.trim());
  }

  onPlaintiffChange(value: string) {
    this.plaintiffSubject.next(value.trim());
  }


  onDefendantChange(value: string) {
    this.defendantSubject.next(value.trim());
  }

  onCourtNameChange(value: string) {
    this.courtNameSubject.next(value.trim());
  }

  onCaseStatusChange(value: string) {
    this.caseStatusSubject.next(value.trim());
  }

  onOptionChange(event: any) {
    this.selectedOption = event.value;
    this.loadLitigationData(1, this.pageSize, this.searchTerm, this.caseNumberSearch, this.plaintiffSearch, this.defendantSearch, this.courtNameSearch);
  }

  clearSearch() {
    this.caseNumberSearch = '';
    this.plaintiffSearch = '';
    this.defendantSearch = '';
    this.courtNameSearch = '';
    this.loadLitigationData(1, this.pageSize, this.searchTerm, this.caseNumberSearch, this.plaintiffSearch, this.defendantSearch, this.courtNameSearch);
  }

  openPdf(value) {
    let url: any = window.open(`${value}`);
    // let url: any = window.open(`http://3.111.249.237/pm_backend/${value}`);
    // let url: any = window.open(`http://3.111.95.5/pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }

  onClick(rowData) {
    console.log('1234',rowData);
    this.loading = true;
     this.LitigationComplaintsService.rerunlitigationLogic({
      "id": rowData?.id,
      "Case Number": rowData["Case Number"],
      "Plaintiff": rowData["Plaintiff"],
      "Defendant":rowData["Defendant"],
      "Filed Date": rowData["Filed Date"],
      "Court Name": rowData["Court Name"],
      "Judge": rowData["Judge"]
    }).subscribe({
      next: (res: any) => {
        this.loadLitigationData(this.currentPage, this.pageSize, this.searchTerm, this.caseNumberSearch, this.plaintiffSearch, this.defendantSearch, this.courtNameSearch);
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  loadLitigationDataLazy(event: any) {
    this.loading = true;

    // const page = event.first / event.rows;
    // const size = event.rows;

    this.currentPage = Math.floor(event.first / event.rows) + 1;
    this.pageSize = event.rows;
    this.loadLitigationData(this.currentPage, this.pageSize, this.searchTerm, this.caseNumberSearch, this.plaintiffSearch, this.defendantSearch, this.courtNameSearch);
  }

  loadLitigationData(page: number, size: number, search: string = '', caseNumber: string = '', plaintiff: string = '', defendant: string = '', courtName: string = '') {
    this.loading = true;

    this.LitigationComplaintsService.getViewAllLitigationComplaintsData({
      user_email: this.email,
      page_number: page,
      per_page_record: size,
      search: search,
      case_captured_filter: this.selectedOption,
      case_number: caseNumber,
      plaintiff: plaintiff,
      defendant: defendant,
      court_name: courtName
    }).subscribe({
      next: (res: any) => {
        this.filteredLitigationData = res.data;
        this.totalRecords = res.total_records;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  

}

